import { Project } from '@brg/api';
import { useAssociatedProfile } from '@brg/auth';
import { ProjectDelegate } from 'project-delegate';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompetitionProjects } from 'shared/actions/competition';
import { CompetitionsSelector } from 'shared/reducers/Competitions';
import { STATUSES } from '_competition/const';

export const useVsCompetition = (project: Project): any => {
    const profile = useAssociatedProfile();
    const { i18n } = useTranslation();
    const dispatch = useDispatch();
    const [isProjectPartInCompetition, setIsProjectPartInCompetition] = useState(false);
    const [ userCanSendToCompetition, setUserCanSendToCompetition ] = useState(false);
    const competitionList = useSelector(CompetitionsSelector)?.vsList;

    const filteredCompetitionList = competitionList?.filter((competition) =>competition?.status !== STATUSES.Completed)?.reduce((result: any, {
        name,
        competitionId,
        nominationsID
    }: any) => {
        const obj = {
            name,
            competitionId,
            nominationsID
        }
        return [...result, obj]

    }, [])

    useEffect(() => {
        //@ts-ignore
        if (project && (!!project?.competitionApproves?.length > 0)) {
            setIsProjectPartInCompetition(true)
        }
    }, [project])

    useEffect(() => {
        if (isProjectPartInCompetition) {
            setUserCanSendToCompetition(false);
        } else {
            setUserCanSendToCompetition(ProjectDelegate.makeProjectToCompetitionsVS(profile, project))
        }
   
    }, [project, profile, isProjectPartInCompetition])

    useEffect(() => {
        if (userCanSendToCompetition) {
          const isVsCtx = ['hsevisualresearch'];
          dispatch(fetchCompetitionProjects({
            limit: 100,
            page: 0,
            contexts: isVsCtx,
            i18n
          }))
        }
      }, [userCanSendToCompetition, dispatch, i18n])

    return [userCanSendToCompetition, filteredCompetitionList];
}import { Project } from '@brg/api';
import { useAssociatedProfile } from '@brg/auth';
import { ProjectDelegate } from 'project-delegate';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompetitionProjects } from 'shared/actions/competition';
import { CompetitionsSelector } from 'shared/reducers/Competitions';
import { STATUSES } from '_competition/const';

export const useVsCompetition = (project: Project): any => {
    const profile = useAssociatedProfile();
    const { i18n } = useTranslation();
    const dispatch = useDispatch();
    const [isProjectPartInCompetition, setIsProjectPartInCompetition] = useState(false);
    const [ userCanSendToCompetition, setUserCanSendToCompetition ] = useState(false);
    const competitionList = useSelector(CompetitionsSelector)?.vsList;

    const filteredCompetitionList = competitionList?.filter((competition) =>competition?.status !== STATUSES.Completed)?.reduce((result: any, {
        name,
        competitionId,
        nominationsID
    }: any) => {
        const obj = {
            name,
            competitionId,
            nominationsID
        }
        return [...result, obj]

    }, [])

    useEffect(() => {
        //@ts-ignore
        if (project && (!!project?.competitionApproves?.length > 0)) {
            setIsProjectPartInCompetition(true)
        }
    }, [project])

    useEffect(() => {
        if (isProjectPartInCompetition) {
            setUserCanSendToCompetition(false);
        } else {
            setUserCanSendToCompetition(ProjectDelegate.makeProjectToCompetitionsVS(profile, project))
        }
   
    }, [project, profile, isProjectPartInCompetition])

    useEffect(() => {
        if (userCanSendToCompetition) {
          const isVsCtx = ['hsevisualresearch'];
          dispatch(fetchCompetitionProjects({
            limit: 100,
            page: 0,
            contexts: isVsCtx,
            i18n
          }))
        }
      }, [userCanSendToCompetition, dispatch, i18n])

    return [userCanSendToCompetition, filteredCompetitionList];
}